/**
 * GroupSearchBar — search field + sort/filter trigger shared by the My Groups
 * and All Groups tabs (Figma 3463-1808).
 */
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { FilterIcon, SearchIcon } from '../../components/ui/icons';
import './groups.css';

interface GroupSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onFilter: () => void;
  inputId: string;
}

export function GroupSearchBar({ value, onChange, onFilter, inputId }: GroupSearchBarProps) {
  const { t } = useTranslation();
  const placeholder = t('home.myGroups.searchPlaceholder');

  return (
    <div className="group-search">
      <div className="group-search__field">
        <label className="sr-only" htmlFor={inputId}>{placeholder}</label>
        <input
          id={inputId}
          className="group-search__input"
          type="search"
          value={value}
          placeholder={placeholder}
          onChange={event => onChange(event.target.value)}
        />
        <SearchIcon size={24} className="group-search__icon" />
      </div>
      <button
        type="button"
        className="group-search__filter"
        onClick={onFilter}
        aria-label={t('home.myGroups.filter')}
      >
        <FilterIcon size={24} />
      </button>
    </div>
  );
}
